import axios from "axios"

import type {
  ReviewDisplayItem,
  ReviewsSummaryData,
} from "@/components/shared/reviews/types"
import type { MediaAttachment } from "@/services/media-upload-service"

export interface ProductReviewItem extends ReviewDisplayItem {
  isPending?: boolean
}

export interface ProductReviewsResponse {
  code?: string
  message?: string
  ok: boolean
  reviews: ProductReviewItem[]
  summary: ReviewsSummaryData
}

export interface ProductReviewPermissionResponse {
  canReview?: boolean
  code?: string
  message?: string
  ok: boolean
  reason?: "purchased" | "not_logged_in" | "not_purchased" | "already_reviewed"
  user?: {
    id: number | string
    name: string
    email: string
  }
}

export interface CreateProductReviewRequest {
  content: string
  rating: 1 | 2 | 3 | 4 | 5
  attachments?: MediaAttachment[]
}

export interface CreateProductReviewResponse {
  code?: string
  message?: string
  ok: boolean
  review?: ProductReviewItem
}

export const buildProductReviewsQueryKey = (productId: number) =>
  ["product-reviews", productId] as const

export const buildProductReviewPermissionQueryKey = (productId: number) =>
  ["product-review-permission", productId] as const

export const getProductReviews = async (
  productId: number
): Promise<ProductReviewsResponse> => {
  const { data } = await axios.get<ProductReviewsResponse>(
    `/api/products/${productId}/reviews`
  )

  return data
}

export const getProductReviewPermission = async (
  productId: number
): Promise<ProductReviewPermissionResponse> => {
  const { data } = await axios.get<ProductReviewPermissionResponse>(
    `/api/products/${productId}/review-permission`
  )

  return data
}

export const submitProductReview = async (
  productId: number,
  payload: CreateProductReviewRequest
): Promise<CreateProductReviewResponse> => {
  const { data } = await axios.post<CreateProductReviewResponse>(
    `/api/products/${productId}/reviews`,
    payload
  )

  return data
}
